import { SlotsService, EventsService } from '.'
import { ApiService } from '~/shared/api'
import { restGetList } from '~/shared/utils/decorators'
import type { RequestService } from '~/services/RequestService'
import type { ServiceRestGetList } from '~/shared/interfaces'
import type { CalendarsListParams } from '~/interfaces/Calendars'
import { CalendarModel } from '~/model/Calendars'
import { toModels } from '~/shared/api/utils'

// eslint-disable-next-line
interface CalendarsService extends ServiceRestGetList {}

@restGetList
// eslint-disable-next-line no-redeclare
class CalendarsService extends ApiService {
  protected route: string = 'calendars/calendars'
  public slots: SlotsService
  public events: EventsService

  constructor(requestService: RequestService) {
    super(requestService)
    this.slots = new SlotsService(requestService)
    this.events = new EventsService(requestService)
  }

  getListModel(params: CalendarsListParams = {}): Promise<Array<CalendarModel>> {
    return this.getList(params).then(toModels(CalendarModel))
  }
}

export default CalendarsService
